/**
 * Cut-to-size shared behaviour.
 *
 * Cut-to-size products are priced per 0.01 m2 "base unit", so a line's cart quantity is
 * not a piece count: one 2.0 x 3.0 m cut is a quantity of 600. Anything that reports or
 * edits a quantity for these lines has to translate through _unit_area, the hidden line
 * item property holding the base units in ONE piece. Its presence is also what marks a
 * line as cut-to-size.
 *
 * Loaded by blocks/cut-to-size-calculator.liquid and snippets/quantity-selector.liquid,
 * both of which may render more than once per page, hence the guard below.
 */
(function () {
  if (window.CutToSize) return;

  /**
   * Base units in one piece, or 0 if this is not a cut-to-size line.
   *
   * @param {object} item - A cart line from /cart.js
   * @returns {number}
   */
  function unitArea(item) {
    var value = parseInt((item.properties || {})._unit_area, 10);
    return value > 0 ? value : 0;
  }

  /**
   * Piece-aware item count for a cart object.
   *
   * Mirrors the Liquid in snippets/cart-bubble.liquid — keep the two in sync. Cut-to-size
   * lines contribute their piece count; every other line contributes its real quantity.
   *
   * @param {object} cart - A cart object from /cart.js
   * @returns {number}
   */
  function displayCount(cart) {
    if (!cart || !cart.items) return 0;

    return cart.items.reduce(function (total, item) {
      var units = unitArea(item);
      return total + (units ? Math.round(item.quantity / units) : item.quantity);
    }, 0);
  }

  /**
   * Tells the theme the cart changed, so cart sections re-render and the header icon
   * updates.
   *
   * itemCount must be the piece count, NOT cart.item_count. The header cart icon does
   * `textContent = value < 100 ? String(value) : ''`, so feeding it a raw base-unit
   * count (600 for a single 6 m2 cut) blanks the badge entirely.
   *
   * @param {object} cart - A cart object from /cart.js
   * @param {string} sourceId - Identifier for the dispatching component
   */
  function notifyCartUpdate(cart, sourceId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sourceId,
          data: { itemCount: displayCount(cart) }
        }
      })
    );
  }

  window.CutToSize = {
    unitArea: unitArea,
    displayCount: displayCount,
    notifyCartUpdate: notifyCartUpdate
  };

  /* ---- cart line stepper --------------------------------------------------
     Bound once on the document rather than per line: the cart morphs its section on
     every update, which discards inline scripts but leaves document listeners intact.
     The visible input holds PIECES; what gets written to the cart is pieces * unitArea. */

  var busy = false;

  function commit(stepper, pieces) {
    if (busy) return;

    var line = parseInt(stepper.dataset.ctsLine, 10);
    var units = parseInt(stepper.dataset.ctsUnitArea, 10);
    if (!line || !units || pieces < 1) return;

    busy = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: pieces * units })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) { notifyCartUpdate(cart, 'cut-to-size-cart-qty'); })
      .catch(function (error) { console.error(error); })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cts-step]');
    if (!button || button.disabled) return;

    var stepper = button.closest('[data-cts-line]');
    if (!stepper) return;

    event.preventDefault();

    var input = stepper.querySelector('[data-cts-pieces]');
    var next = (parseInt(input.value, 10) || 1) + parseInt(button.dataset.ctsStep, 10);
    if (next < 1) return;

    input.value = next;
    commit(stepper, next);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-cts-pieces]');
    if (!input) return;

    var stepper = input.closest('[data-cts-line]');
    if (!stepper) return;

    var next = parseInt(input.value, 10);
    if (isNaN(next) || next < 1) next = 1;

    input.value = next;
    commit(stepper, next);
  });
})();
